import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Typography from 'material-ui/Typography'
import Card, { CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import Badge from 'material-ui/Badge'
import styles from './styles'
import { getFormattedNumberWithPrecision } from '../../../../../common/utils'
class ResistanceUnbalancedSubTests extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      direction: 'row',
      justify: 'center',
      alignItems: 'center'
    }
  }

  componentWillMount() {
    const { getSubtestResults, subtest, pager } = this.props
    getSubtestResults(pager.jid, pager.tid, subtest, 0)
  }

  componentWillReceiveProps(nextProps) {
    const {
      getSubtestResults,
      subtest,
      pager,
      subtestResultsDisplay,
      subtestResultsRemote
    } = nextProps

    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      if (!subtestResultsDisplay[subtest]) {
        getSubtestResults(pager.jid, pager.tid, subtest, 0)
      }
    }
  }

  PairResultsViewer = (state) => {

    const { classes } = this.props
      if (state === 'MarginalPass') {
        return (
          <Badge badgeContent={"!"} className={classes.passStateBadge}>
            <Icon className={classes.passState}>check_circle</Icon>
          </Badge>
        )
      } else if (state === 'MarginalFail') {
          return (
            <Badge badgeContent={"!"} className={classes.failStateBadge}>
              <Icon className={classes.failState}>cancel</Icon>
            </Badge>
          )
      } else if (state === 'Pass') {
          return (<Icon className={classes.passState}>check_circle</Icon>)
      } else if (state === 'Info') {
          return (<Icon className={classes.passState}>info</Icon>)
      }
        else {
          return (<Icon className={classes.failState}>cancel</Icon>)
      }
  }


  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtestResultsRemote,
      subtest
    } = this.props

    const { alignItems, direction, justify } = this.state


    if (subtestResultsDisplay[subtest]) {

      let p2p = subtestResultsDisplay[subtest].pairtopair
      let p2pData, p2pPairResult, p2pPairs, p2pLimitIdx, p2plimitVal
      if(p2p) {
        p2pData = p2p ? p2p.data[0] : null
        p2pPairResult = p2p.pairResults
        p2pPairs = p2p.pairs
        p2pLimitIdx = p2pPairs.findIndex(x => x === 'Limit')
        p2pPairs = p2pLimitIdx !== -1 ? p2pPairs.slice(0, -1) : p2pPairs
        p2plimitVal = p2pLimitIdx !== -1 ? p2pData[p2pLimitIdx] : p2pData[p2pPairs.length-1]
      }
      const data = subtestResultsDisplay[subtest].data[0]
      const pairResult = subtestResultsDisplay[subtest].pairResults
      let pairs = subtestResultsDisplay[subtest].pairs
      const limitIdx = pairs.findIndex(x => x === 'Limit')
      pairs = limitIdx !== -1 ? pairs.slice(0, -1) : pairs
      let limitVal = data[limitIdx] !== -1 ? data[limitIdx] : data[pairs.length-1]

      const passed = subtestResultsDisplay[subtest].subteststatus !== 'Fail'
      const P2Ppassed = p2p ? p2p.subteststatus !== 'Fail' : ''
      return (
        <React.Fragment>
        <Grid container className={classes.root} justify='center'>
          <Grid item xs={8}>
            <Card
              className={passed ? classes.borderpassed : classes.borderfailed}
            >
              <CardContent className={classes.cardContent}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>

                    <Grid
                      container
                      spacing={16}
                      className={classes.demo}
                      alignItems={alignItems}
                      direction={direction}
                      justify={justify}
                    >
                      <Grid item>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>{translate("general_pairs")}</TableCell>
                              <TableCell>{translate("measurement_value")}</TableCell>
                              <TableCell>{translate("general_pass_fail_header")}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {pairs.map((pair, key) => {
                              return(
                                <TableRow key={key} >
                                <TableCell className={classes.commonPadding} component='th' scope='row'>
                                  {pair}
                                </TableCell>
                                <TableCell className={classes.commonPadding} numeric>
                                  {getFormattedNumberWithPrecision(data[key], 3)}
                                </TableCell>
                                {<TableCell numeric className={classes.commonPadding}>
                                {pairResult && this.PairResultsViewer(pairResult[0][key])}
                                </TableCell>}
                              {key === 0 && <TableCell className={classes.commonPadding} rowSpan={pairs.length}>
                              {translate('general_limit')} {getFormattedNumberWithPrecision(limitVal, 3)} (&#8486;)
                              </TableCell>}
                              </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </Grid>

                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={
                      passed ? classes.subtestpassed : classes.subtestfailed
                    }
                  >
                    <Typography
                      variant='headline'
                      component='h2'
                      className={classes.subtesttitle}
                    >
                      {/* passed */}
                      {translate(subtest)}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          </Grid>
        { p2p && <Grid container className={classes.root} justify='center'>
          <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
            <Card
              className={P2Ppassed ? classes.borderpassed : classes.borderfailed}
            >
              <CardContent className={classes.cardContent}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid
                      container
                      spacing={16}
                      className={classes.demo}
                      alignItems={alignItems}
                      direction={direction}
                      justify={justify}
                    >
                      <Grid item>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>{translate("general_pairs")}</TableCell>
                              <TableCell>{translate("measurement_value")}</TableCell>
                              <TableCell>{translate("general_pass_fail_header")}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          {p2pPairs && p2pPairs.map((pair, key) => {
                              return(
                                <TableRow key={key}>
                                  <TableCell component='th' scope='row' className={classes.commonPadding}>
                                    {pair}
                                  </TableCell>
                                  <TableCell numeric className={classes.commonPadding}>
                                    {getFormattedNumberWithPrecision(p2pData[key], 3)}
                                  </TableCell>

                                  <TableCell numeric className={classes.commonPadding}>
                                    {this.PairResultsViewer(p2pPairResult[0][key])}
                                  </TableCell>
                                  {key === 0 && <TableCell className={classes.commonPadding} rowSpan={p2pPairs.length}>
                                    {translate('general_limit')} {getFormattedNumberWithPrecision(p2plimitVal, 3)} (&#8486;)
                                  </TableCell> }
                              </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={
                      P2Ppassed ? classes.subtestpassed : classes.subtestfailed
                    }
                  >
                    <Typography
                      variant='headline'
                      component='h2'
                      className={classes.subtesttitle}
                    >
                      {/* passed */}
                      {p2p && translate(p2p.subtesttypeid)}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          </Grid>}
          </React.Fragment>
      )
    }
    return null
  }
}

export default withStyles(styles)(ResistanceUnbalancedSubTests)
